import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    position: 'absolute',
    top: '24px',
    left: '24px',
    marginBottom: '0px',
    fontSize: theme.size.lg,
    color: '#3C425B'
  },

  modalClose: {
    top: '24px',
    right: '24px'
  },

  mobileChildren: {
    height: '100svh',
    maxHeight: 'unset'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    padding: '24px'
  },

  mobileRoot: {
    marginTop: '0',
    paddingTop: '0'
  },

  title: {
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  mobileTitle: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0 22px 0',

    '& > span': {
      fontSize: theme.size.lg,
      color: '#1F1F1F'
    }
  },

  mobileBackArrow: {
    marginRight: '16px',
    cursor: 'pointer'
  },

  participants: {
    marginBottom: '24px',
    maxHeight: '244px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#E5E5E5'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  participant: {
    display: 'flex',
    alignItems: 'center',

    '&:not(:last-child)': {
      marginBottom: '16px'
    }
  },

  participantAvatar: {
    width: '36px',
    height: '36px'
  },

  participantName: {
    marginLeft: '16px',
    marginRight: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  participantRemove: {
    fontSize: theme.size.sm,
    color: '#FF3B3B',
    cursor: 'pointer',
    userSelect: 'none'
  },

  participantRemoveDisabled: {
    opacity: '0.5',
    cursor: 'default'
  },

  radio: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px'
  },

  radioButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '& span': {
      marginLeft: '8px',
      fontSize: theme.size.base,
      color: '#1F1F1F'
    },

    '&:not(:last-child)': {
      marginRight: '24px'
    }
  },

  inputArea: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    borderBottom: '1px solid #C6C6C6',
    cursor: 'text',

    '&:focus-within': {
      borderBottomColor: 'black'
    }
  },

  inputItem: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    marginRight: '8px',
    marginBottom: '8px',
    height: '36px',
    padding: '0 10px 0 12px',
    cursor: 'default'
  },

  inputItemAvatar: {
    width: '24px',
    height: '24px',
    fontSize: theme.size.sm
  },

  inputItemName: {
    margin: '0 10px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  inputItemDelete: {
    cursor: 'pointer'
  },

  input: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    border: 'none',
    outline: 'none',

    '&::placholder': {
      color: '#8F8F8F'
    }
  },

  resultsContainer: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white',

    '& > ul': {
      padding: '0'
    }
  },

  resultsTitle: {
    marginBottom: '8px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  results: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '208px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#E5E5E5'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  result: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: '#3C425B',

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  buttonArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '16px -24px -24px -24px',
    height: '96px',
    paddingRight: '24px',
    background: '#F5F6F8',
    borderRadius: '0px 0px 8px 8px'
  },

  buttonAreaSub: {
    justifyContent: 'center',
    padding: '0',
    columnGap: '16px',

    '& button': {
      flex: '1',
      maxWidth: '200px'
    }
  },

  buttonAreaMobile: {
    position: 'absolute',
    bottom: '24px',
    left: '24px',
    right: '24px',
    margin: '0',
    height: 'auto',
    padding: '0'
  },

  button: {
    height: '48px'
  },

  fullWidthButton: {
    width: '100%'
  },

  buttonGreyRoot: {
    borderColor: '#8F8F8F',
    color: '#8F8F8F'
  },

  buttonGreyMobileRoot: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  },

  buttonGreyLabel: {
    fontSize: theme.size.base
  },

  submodalMobileRoot: {
    marginTop: '0'
  },

  submodalTitle: {
    marginBottom: '8px',
    fontSize: theme.size.lg,
    textAlign: 'center',
    color: '#3C425B'
  },

  submodalText: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    textAlign: 'center',
    color: '#3C425B',

    '& span': {}
  },

  submodalButtonAreaMobile: {
    columnGap: '9px',
    padding: '0 22px'
  }
}))

export default useStyles
